module.exports = __webpack_public_path__ + "img/Aspi.8985acb4.jpg";